/**
 * Predefined Table columns enum.
 * These values are supposed to be used when preparing table data and columns.
 */
export enum Columns {
    ID = 'Lead_ID',
    NEW = 'Is_New',
    ADDRESS = 'Address',
    MARKET_VALUE = 'Estimated_Market_Value',
    CITY = 'City',
    STATE = 'State',
    ZIP = 'Zip_Code',
    EDM = 'EDM',
    LEAD_TYPE = 'Lead_Type',
    DATE_ADDED = 'Date_Added',
    DATE_UPDATED = 'Date_Updated',
    DISPLAYED_MARKET_VALUE = 'Displayed_Market_Value',
    TOTAL_MARKET_VALUE = 'Total_Market_Value',
}

export enum EdmColumns {
    ID = 'edmId',
    NAME = 'name',
    PHONES = 'phones',
    EMAILS = 'emails',
    ADDRESSES = 'addresses',
    AGE = 'age',
}

export enum HiddenColumns {
    EDMS = 'EDMs',
    OWNER1 = 'Owner 1',
    OWNER2 = 'Owner 2',
    OBIT_FIRST_NAME = 'Obit_First_Name',
    OBIT_LAST_NAME = 'Obit_Last_Name',
}

export enum APIColumns {
    ID = 'propertyLeadId',
    OWNERS = 'owners',
    ADDRESS = 'address',
    MARKET_VALUE = 'estimatedMarketValue',
    CITY = 'city',
    STATE = 'state',
    ZIP = 'zip',
    EDMS = 'edms',
    LEAD_TYPE = 'leadType',
    OBIT_FIRST_NAME = 'obitFirstName',
    OBIT_LAST_NAME = 'obitLastName',
    IS_LISTED = 'isListed',
    DATE_ADDED = 'created',
}

// IDS used for sortin and header alignment
export enum ColumnsSortId {
    ADDRESS = 'address',
    MARKET_VALUE = 'estimatedMarketValue',
    CITY = 'city',
    STATE = 'state',
    ZIP = 'zip',
    EDM = 'edms',
    LEAD_TYPE = 'lead_type',
    DATE_ADDED = 'created',
    DATE_UPDATED = 'updated',
    TOTAL_MARKET_VALUE = 'totalMarketValue',
}

export const SelectableColumns = [
    {
        value: Columns.ADDRESS,
        label: 'Property addresses',
    },
    { value: EdmColumns.NAME, label: 'EDM names' },
    { value: EdmColumns.EMAILS, label: 'EDM emails' },
    { value: EdmColumns.PHONES, label: 'EDM phone numbers' },
    { value: EdmColumns.ADDRESSES, label: 'EDM addresses' },
];
